export class perfil{
    id?: number;
    nombre?: string;
}